import type { ImpersonationDetails } from "../../common/interfaces/impersonation";

export const ENTRA_CODE_VERIFIER_KEY = "entraCodeVerifier";
export const ENTRA_STATE_NONCE_KEY = "entraStateNonce";

export type EntraAuthState = {
  aboNumber: string;
  salesPlanAff: string;
  partyId?: string;
  nonce: string;
  provider: "entra";
};

export const encodeEntraState = (state: EntraAuthState): string => window.btoa(JSON.stringify(state));

export const decodeEntraState = (encodedState: string): EntraAuthState => {
  const state = JSON.parse(window.atob(encodedState)) as Partial<EntraAuthState>;

  if (
    typeof state.aboNumber !== "string" ||
    state.aboNumber.length === 0 ||
    typeof state.salesPlanAff !== "string" ||
    state.salesPlanAff.length === 0 ||
    typeof state.nonce !== "string" ||
    state.nonce.length === 0 ||
    state.provider !== "entra"
  ) {
    throw new Error("Invalid Entra authentication state");
  }

  return state as EntraAuthState;
};

export const launchEntraImpersonation = ({
  abo,
  spcode,
  locale,
  partyId,
}: Pick<ImpersonationDetails, "abo" | "spcode" | "locale" | "partyId">) => {
  const params = new URLSearchParams({
    abo,
    aff: spcode!,
    locale,
  });

  if (partyId) {
    params.set("partyId", partyId);
  }

  window.open(`/entra-login.html?${params.toString()}`, "_blank");
};
